module.exports = {"id":"230181","name":"Heitor Gesse","rating":"71","photo":"./data/images/photos/4/230181.png","club":{"name":"São Paulo","logo":"./data/images/clubs/SaoPaulo.png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HeitorGesse0.json
// module id = 1716
// module chunks = 0